import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { SlickCarouselComponent } from 'ngx-slick-carousel';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit {
  @Input() data: any;
  @Input() dataFeatures: any;
  @Input() type: any;
  @ViewChild('slickModal') slickModal: SlickCarouselComponent;

  constructor() { }

  ngOnInit(): void { }

  /**
   * -------------------------------------------------------
   * @summary slideConfig
   * @description  Configuracion de Banner Slider
   * -------------------------------------------------------
   */
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    cssEase: 'linear',
    fade: false,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  /**
   * -------------------------------------------------------
   * @summary slickInit
   * @description  Inicializacion del Banner Slider
   * -------------------------------------------------------
   */
  slickInit(e) {
    // console.log('slick initialized');
  }

  /**
   * -------------------------------------------------------
   * @summary breakpoint
   * @description  Breakpoint del Banner Slider
   * -------------------------------------------------------
   */
  breakpoint(e) {
    // console.log('breakpoint');
  }

  /**
   * -------------------------------------------------------
   * @summary afterChange
   * @description  afterChange del Banner Slider
   * -------------------------------------------------------
   */
  afterChange(e) {
    // console.log('afterChange');
  }

  /**
   * -------------------------------------------------------
   * @summary beforeChange
   * @description  beforeChange del Banner Slider
   * -------------------------------------------------------
   */
  beforeChange(e) {
    // console.log('beforeChange');
  }

  /**
   * -------------------------------------------------------
   * @summary next
   * @description  Boton Next del Banner Slider
   * -------------------------------------------------------
   */
  next() {
    this.slickModal.slickNext();
  }

  /**
   * -------------------------------------------------------
   * @summary prev
   * @description  Boton Prev del Banner Slider
   * -------------------------------------------------------
   */
  prev() {
    this.slickModal.slickPrev();
  }
}
